import React from 'react';
import styled from 'styled-components';
import ColorConstants from '../../../shared/constants/ColorConstants';

const defaultProps = {
    children: null,
};

export const SelectSingleValue = ({
    data,
    children,
    selectProps,
}) => (
    <SelectSingleValueTag
        data-testid={selectProps?.testIds?.SingleValue && `${selectProps?.testIds?.SingleValue}-${data.value}`}
    >
        { children || data.label }
    </SelectSingleValueTag>
);

SelectSingleValue.defaultProps = defaultProps;

export const SelectSingleValueStyles = () => ({});

export const SelectSingleValueTag = styled.div`
    color: ${ColorConstants['regal-blue']};
    font-family: Helvetica, sans-serif;
    font-size: 16px;
    line-height: 12px;
    padding: 14px 8px;
`;
